import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';

import AllBanksTable from 'components/AllBanksTable';

import {
  getBanksRatesWithInfo,
  getLocationParamsValues,
  getCurrenciesPairInfo,
  // for withSeoData
  getCurrencyRatesByCurrencyPair,
  getExistedConverterType,
} from 'selectors';

const mapStateToProps = (state, props) => {
  const { sourceValue, sourceType } = getLocationParamsValues(state, props);

  return {
    ...getCurrenciesPairInfo(state, props),
    ...getCurrencyRatesByCurrencyPair(state, props),

    sourceType,
    sourceValue,
    existedConverterType: getExistedConverterType(state, props),
    banks: getBanksRatesWithInfo(state, props),
  };
};

const AllBanksTableContainer = injectIntl(
  withRouter(connect(mapStateToProps)(AllBanksTable))
);

export default AllBanksTableContainer;
